// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2lWxo","description":"PatientConsentPreview_description__1e9R7"};